import styled from "styled-components";

export const Content = styled.div`
  max-width: 480px;
  margin: 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;

  padding: 20px 0px 20px 0px;

  width: 400px;

  > h3 {
    color: #666666;

    font-weight: 600;
    font-weight: bold;
  }

  @media (max-width: 767px) {
    padding: 24px 0 24px 0px;

    width: 330px;
  }
`;

export const FormContainer = styled.form`
  width: 80%;

  padding-bottom: 8px;

  align-items: flex-start;
  flex-direction: row;

  margin: 40px 40px 0px;
  font-size: 18px;
  color: #666666;

  position: relative;

  > p {
    font-weight: bold;
    margin: 24px 0 8px;
  }

  > input {
    font-size: 18px;
    width: 100%;

    padding: 8px 0px 8px 0px;

    border: 0;
    border-bottom: 1px solid #b6b6b6;

    cursor: default;
  }

  .iconContainer {
    position: absolute;
    right: 2%;
    top: 15%;
    cursor: pointer;
  }

  #consultants {
    width: 100%;
    max-height: 350px;

    overflow-y: auto;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    flex-direction: column;

    position: absolute;

    left: 50;
    top: 25;
    z-index: 10000;

    background: #ffffff;

    border: 1px solid #b6b6b6;

    > button {
      padding: 8px 16px;

      width: 100%;

      font-size: 14px;

      text-align: start;

      transition: all 0.2s;

      &:hover {
        background: #f9f9f9;
      }
    }
  }

  #consultants {
    width: 21.5%;
    max-height: 350px;

    overflow-y: auto;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    flex-direction: column;

    position: fixed;

    left: 50;
    top: 25;
    z-index: 10000;

    background: #ffffff;

    border: 1px solid #b6b6b6;

    > button {
      padding: 8px 16px;

      width: 100%;

      font-size: 14px;

      text-align: start;

      transition: all 0.2s;

      &:hover {
        background: #f9f9f9;
      }
    }
  }
  select{
		background: transparent;

		padding-left: 12px;

		font-size: 11px;
		font-weight: 500;

		/* width: 80%; */
		height: 35px;

		border: 0;
		border-bottom: 1px solid #B6B6B6;

		-moz-appearance: none;
	    -webkit-appearance: none;
	    appearance: none;

	    background-repeat: no-repeat, repeat;
		background-position: right .7em top 50%, 0 0;
		background-size: .95em auto, 100%;
	}

	.css-2b097c-container{
		width: 100%;
	}

	.css-yk16xz-control{
		border: 0;
		border-bottom: 1px solid #B6B6B6;

		border-radius: 0;
	}

	.css-1okebmr-indicatorSeparator{
		display: none;
	}

	.css-tlfecz-indicatorContainer{
		color: #666666;
	}
`;

export const ButtonContainer = styled.div`
  margin: 24px 20px 16px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 90%;

  > button {
    font-size: 18px;
    padding: 12px;

    margin: 8px 8px;
    color: #fff;

    font-weight: 500;
  }

  .btn-edit {
    background-color: #03bf34;
    font-weight: bold;
  }
  .btn-close {
    color: #666666;
    border: 2px solid #666666;
    font-weight: bold;
  }

  @media (max-width: 767px) {
    width: 90%;
  }
`;

export const FieldContent = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  > p {
    font-size: 14px;
    color: #666;
    margin: 4px 0;
    line-height: 1.5;

    > b {
      font-weight: bold;
      color: #333;
    }
  }
`;

export const FieldTitle = styled.h4`
  font-size: 12px;
  font-weight: bold;
  color: #666;
  text-transform: uppercase;
  margin: 0 0 12px 0;
  letter-spacing: 0.5px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0 16px;
  min-height: 28px;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0 10px 0 0;
    accent-color: #dd6435;
    cursor: pointer;
    flex-shrink: 0;
  }

  label {
    cursor: pointer;
    color: #666666;
    font-size: 16px;
    font-weight: 500;
    user-select: none;
    line-height: 1.3;
  }
`;

